import { effects } from './effects'
import { palette } from './palette'
import { copernicoPalette } from './copernicoPalette'
import { breakpoints } from './breakpoints'
import { typography, overrides } from './typography'
import './resize'
import './index.css'

const defaultTheme = {
  palette,
  typography,
  overrides,
  breakpoints
}

const copernicoTheme = {
    palette: copernicoPalette,
    typography,
    overrides,
    breakpoints
  }

export {
  effects,
  defaultTheme,
  copernicoTheme,
  palette,
  copernicoPalette
}